import {Article, Build} from '@mui/icons-material';
import {Grid} from '@mui/material';
import React, {useEffect, useState} from 'react';
import Api from "../../../common/Api";
import {IAppInfoDto} from "../../../common/apis/Common";
import {DateTimeFormatter} from "../../../common/DateTimeFormatter";
import TextField from "../../../components/fields/textfield/TextField";
import Page from "../../../components/page/Page";
import PageContent from "../../../components/page/PageContent";
import PageHeader from "../../../components/page/PageHeader";
import PageTitle from "../../../components/page/PageTitle";
import SectionHeader from "../../../components/section/SectionHeader";
import {FetchStatusType} from "../../../store/common/FetchableResource";
import {t} from "../../../store/localization/TranslMessasge";
import {AppBarTranslationKey} from "../appbar/AppBarTranslationKey";
import {AppInfoTranslationKey} from "./AppInfoTranslationKey";

const linkFieldStyle = {
    cursor: 'pointer',
    '& input': {
        cursor: 'pointer',
        textDecoration: 'underline',
        color: '#0000EE'
    }
};

export default function AppInfoPage() {
    const [fetchStatus, setFetchStatus] = useState<FetchStatusType>(FetchStatusType.NOT_STARTED);
    const [data, setData] = useState<IAppInfoDto | undefined>(undefined);

    useEffect(() => {
        setFetchStatus(FetchStatusType.STARTED);
        Api.common.fetchAppInfoDto(
            (data) => {
                setFetchStatus(FetchStatusType.SUCCESSFUL);
                setData(data);
            },
            () => {
                setFetchStatus(FetchStatusType.FAILED);
                setData(undefined);
            }
        );
    }, []);

    function formatVersion(version: string | undefined, buildNumber: string | undefined): string {
        if (version && buildNumber) {
            return `${version}.${buildNumber}`;
        }
        return "";
    }

    return (
        <Page>
            <PageHeader>
                <PageTitle title={t(AppBarTranslationKey.APP_INFO)}/>
            </PageHeader>
            <PageContent>
                {fetchStatus === FetchStatusType.STARTED && (
                        <div>{t(AppInfoTranslationKey.LOADING)}</div>
                )}
                {fetchStatus === FetchStatusType.FAILED && (
                        <div>{t(AppInfoTranslationKey.DATA_LOAD_FAILED)}</div>
                )}
                {fetchStatus === FetchStatusType.SUCCESSFUL && (
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <SectionHeader
                                                icon={<Article color="primary" />}
                                                title={t(AppInfoTranslationKey.BASIC_INFO)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                                id="product"
                                                label={t(AppInfoTranslationKey.PRODUCT)}
                                                value={data?.name ?? ""}
                                                readOnly/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                                id="web"
                                                label={t(AppInfoTranslationKey.WEB)}
                                                value={data?.url ?? ""}
                                                readOnly
                                                onClick={() => data?.url && window.open(data.url, '_blank', 'noopener,noreferrer')}
                                                sx={linkFieldStyle}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                                id="helpdesk"
                                                label={t(AppInfoTranslationKey.HELPDESK)}
                                                value={data?.email ?? ""}
                                                readOnly
                                                onClick={() => data?.email && window.open(`mailto:${data.email}`)}
                                                sx={linkFieldStyle}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <SectionHeader
                                                icon={<Build color="primary" />}
                                                title={t(AppInfoTranslationKey.COMPILATION)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                                id="version"
                                                label={t(AppInfoTranslationKey.VERSION_AND_COMPILATION)}
                                                value={formatVersion(data?.version, data?.buildNumber)}
                                                readOnly/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                                id="date"
                                                label={t(AppInfoTranslationKey.DATE_OF_COMPILATION)}
                                                value={DateTimeFormatter.formatDate(data?.buildDate) ?? ""}
                                                readOnly/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                                id="notes"
                                                label={t(AppInfoTranslationKey.RELEASE_NOTES)}
                                                value={t(AppInfoTranslationKey.RELEASE_NOTES)}
                                                readOnly
                                                onClick={() => data?.releaseNotes && window.open(data.releaseNotes, '_blank', 'noopener,noreferrer')}
                                                sx={linkFieldStyle}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                )}
            </PageContent>
        </Page>
    );
}
